/**
 * The sign-in page's return destination.
 *
 * `next` comes from the address bar, so anyone can write it. Only an on-site
 * absolute path is followed, and never the sign-in pages themselves, which
 * would bounce the visitor straight back (a redirect loop).
 */
const AUTH_PAGES = /^\/(login|signup)(?=$|[/?#])/;

export function safeNextPath(raw, fallback = '/dashboard') {
  if (typeof raw !== 'string' || !raw.startsWith('/')) return fallback;
  // "//host" and "/\host" are read by browsers as another site.
  if (raw.startsWith('//') || raw.startsWith('/\\')) return fallback;
  if (AUTH_PAGES.test(raw)) return fallback;
  return raw;
}

/** "/login", carrying `next` when it is a destination we would follow. */
export function loginPath(next) {
  const safe = safeNextPath(next, null);
  return safe ? `/login?next=${encodeURIComponent(safe)}` : '/login';
}
